export default __webpack_public_path__ + "static/media/InfografiaEsalariumFinal.c3670ec0.png";